export default __webpack_public_path__ + "static/media/megaphone.e81d29dc.svg";